// Shared color tokens for the Portfolio-construction feature. These were
// previously redeclared in every panel/prompt; centralized here so the palette
// stays consistent. Some call sites use different local names for the same value
// (e.g. "over" === "error"); those are kept as explicit aliases below.

// Text
export const COLOR_PRIMARY = "#071f35";
export const COLOR_SECONDARY = "#496682";
export const COLOR_DISABLED = "#92a7bc";
export const COLOR_VALUE = "#26a6ae";
export const COLOR_AI = "#7c3aed";

// Strokes / dividers
export const COLOR_STROKE_IDLE = "#7b92a9";
export const COLOR_STROKE_DIVIDER = "#dbe8f5";

// Backgrounds
export const COLOR_BG_SUBTLE = "#f6f8fc";
export const COLOR_BG_INFO = "#eaf3fb";

// Status: info
export const COLOR_INFO = "#1c6db5";

// Status: error
export const COLOR_ERROR = "#d93e3e";
export const COLOR_ERROR_BG = "#fcebea";

// Status: warning
export const COLOR_WARN_BG = "#fff7e6";
export const COLOR_WARN_BORDER = "#f5b14b";
export const COLOR_WARN_TEXT = "#7a4400";

// Status: success
export const COLOR_SUCCESS_BG = "#e6f6ec";
export const COLOR_SUCCESS_BORDER = "#7fc99a";
export const COLOR_SUCCESS_TEXT = "#2e7d32";

// Drift table
export const COLOR_NEUTRAL_BG = "#eef2f7";
export const COLOR_BAR_TARGET = "#c2a05a";

// Aliases — same value, different call-site name.
export const COLOR_BG_HOVER_SUBTLE = COLOR_BG_SUBTLE;
export const COLOR_NEUTRAL = COLOR_DISABLED;
export const COLOR_BAR_ACTUAL = COLOR_PRIMARY;
export const COLOR_OVER = COLOR_ERROR;
export const COLOR_OVER_BG = COLOR_ERROR_BG;
export const COLOR_UNDER = COLOR_INFO;
export const COLOR_UNDER_BG = COLOR_BG_INFO;
